// src/hooks/usePosts.ts
import { useQuery } from "@tanstack/react-query";
import { wpApi } from "../services/wpApi";

export type Post = {
  id: number;
  slug: string;
  title: { rendered: string };
  excerpt: { rendered: string };
  content: { rendered: string };
  _embedded?: any;
};

export type PostsResponse = {
  posts: Post[];
  total: number;
  totalPages: number;
};

export function usePosts(page = 1, perPage = 10) {
  return useQuery<PostsResponse, Error>({
    queryKey: ["posts", page, perPage],
    queryFn: async () => {
      const res = await wpApi.get("/wp/v2/posts", {
        params: { _embed: true, per_page: perPage, page },
      });
      return {
        posts: res.data as Post[],
        total: Number(res.headers["x-wp-total"] || 0),
        totalPages: Number(res.headers["x-wp-totalpages"] || 0),
      };
    },
    // pagination UX: keepPreviousData is handy but in some typings it can complain.
    // If your version allows it, you can add: keepPreviousData: true,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
